<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="网关详情-完善中" name="1">
            <div>
              <el-row>
                <el-col :span="3" style="text-align: right"
                  ><span>网关名称：</span></el-col
                >
                <el-col :span="9">&nbsp;{{ form.gatewayName }}</el-col>
                <el-col :span="3" style="text-align: right">网关编码：</el-col>
                <el-col :span="9">&nbsp;{{ form.gatewayCode }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="3" style="text-align: right"
                  ><span>站点名称：</span></el-col
                >
                <el-col :span="9">&nbsp;{{ form.stationName }}</el-col>
                <el-col :span="3" style="text-align: right">网关类型：</el-col>
                <el-col :span="9">&nbsp;
                  <span v-if="form.type==3">W1</span>
                  <span v-if="form.type==5">ZY</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="3" style="text-align: right"
                  ><span>备注信息：</span></el-col
                >
                <el-col :span="21">&nbsp;{{ form.remark }}</el-col>
              </el-row>
            </div>
            <div></div>
          </el-collapse-item>
          <el-collapse-item title="设备信息" name="2">
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
    <el-row>
            <equipment-table ref="EquipmentTable" :parentGatewayId="parentGatewayId" />

    </el-row>
  </div>
</template>
<script>
import { apiGet } from "./pile-net";
import EquipmentTable from "./EquipmentTable";
export default {
  name: "gateway-detail",
  components: { EquipmentTable },
  data() {
    return {
      activeNames: ["1"],
      parentGatewayId: null,
      form: {},
    };
  },
  created() {
  },
  mounted() {
    this.form.id = this.$route.query.id;
    this.parentGatewayId=this.form.id;
    this.loadDetail(this.form.id);
    setTimeout(this.handleEquipmentTableInit,2000);
  },
  methods: {
    loadDetail(id) {
      // console.log('加载网关详情');
      apiGet(id).then((resp) => {
        this.form = resp.data;
      });
    },
    handleEquipmentTableInit() {
      this.parentGatewayId = this.$route.query.id;
      console.log('==============初始化网关设备==============');
      this.$refs.EquipmentTable.$emit("listEquipments", {
        gatewayId: this.$route.query.id,
        stationId:this.$route.query.stationId,
        buttonVisible:false
      });
    },
    handleChange(val) {
      console.log(val);
    },
  },
};
</script>